<div class="preamble">
  <h2>Select category</h2>
</div>

<p>For this lot on plan and selected purpose, these are the allowable vegetation categories in which clearing can occur.
Please select all that apply:</p>
<form [formGroup]="form" class="form">
  <ol class="questions">
    <li>
      <ul class="choices">
        @for (c of categoriesRefData; track c) {
          <li>
            <label>
              <input type="checkbox" [formControlName]="'categoryPurposeId_' + c.categoryPurposeId" />Category {{c.categoryCode}}
            </label>
          </li>
        }
      </ul>
    </li>
  </ol>
  @if (form.hasError('categorySelectionRequiredValidationError') && !form.pristine) {
    <div class="alert alert-warning">
      <p><i class="fa fa-exclamation-triangle"></i>You need to select at least one category to continue with the notification.</p>
    </div>
  }
  @if (isProposedCategorySelected) {
    <div class="alert alert-warning">
      <h2><i class="fa fa-exclamation-triangle"></i>Proposed Changes</h2>
      <p>This lot is affected by proposed changes to regulate high value regrowth vegetation and regrowth
        vegetation within 50 metres of a watercourse in reef catchments. Any clearing in a proposed Category C
        or Category R area, must be undertaken in accordance with the relevant accepted development vegetation
        clearing code. For further information please <a
        href="https://www.resources.qld.gov.au/our-department/contact-us/vegetation-contacts" target="_blank">contact
      the Hub</a> on 135VEG (135 834).</p>
    </div>
  }

  @if (selectedcategoryPurposeIds$ | async) {
    <div>
      @if (shouldShowIsNotificationAreaWarningMessage) {
        <div class="alert alert-warning">
          <p [innerHTML]="getNotificationClearingAreaLimitMessage()"></p>
        </div>
      }
      @if (shouldShowIsNotificationAreaInfoMessage) {
        <div class="alert alert-info">
          <p [innerHTML]="getNotificationClearingAreaLimitMessage()"></p>
        </div>
      }
    </div>
  }

  @if (showPreviousNotifications) {
    <div>
      @if (purposeIsThinning) {
        <div class="alert alert-warning">Due to recent changes to the Managing thickened
          vegetation accepted development vegetation clearing code only one notification per lot on plan is permitted.
          Subsequent notifications will not be compliant with the requirements of this code.
        If you require assistance contact the Vegetation Management Hub on 135 VEG or 135 834.</div>
      }
      <h3>Previous notifications for this lot on plan</h3>
      <table class="w-100">
        <thead>
          <th>Notification Number</th>
          @if (purposeIsThinning) {
            <th>Area Notified</th>
          }
          @if (purposeIsThinning) {
            <th>% Notified</th>
          }
          <th>Notification Date</th>
          <th>End Date</th>
        </thead>
        <tbody>
          @for (pfn of previousNotifications; track pfn) {
            <tr>
              <td>{{pfn.title}}</td>
              @if (purposeIsThinning) {
                <td>{{pfn.areaAmount | number:'1.2-2'}} ha</td>
              }
              @if (purposeIsThinning) {
                <td>{{pfn.percentCleared | number:'1.2-2'}} ha</td>
              }
              <td>{{pfn.startDate|date:"dd/MM/yyyy"}}</td>
              <td>{{pfn.endDate|date:"dd/MM/yyyy"}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
  <br/>
  @if (shouldShowCoordinatedProjectsMessage) {
    <div class="alert alert-info"><i class="fa fa-info-circle"></i>The essential habitat, endangered regional
    ecosystem and of concern regional ecosystem area limits apply to the total clearing area for the coordinated project.
    Please call 135 VEG (135 834) to discuss your requirements.
  </div>
}
@if (!selectedCategoryPurposesAreInAllowedLGAList && selectedcategoryPurposeIds$.getValue().length > 0) {
  <div class="alert alert-warning">Fodder
  harvesting is not permitted in this local government area under the code.</div>
}
<li class="footer">
  <ul class="actions">
    <li> <input class="qg-btn btn-global-secondary" type="button" (click)="previous()" value="Previous" /> </li>
    <li> <em> <input class="qg-btn btn-primary" type="submit" (click)="next()" value="Next"
    in-progress-text="Saving..." /> </em> </li>
  </ul>
  <ul class="actions">
    <li>
      <a href="#" (click)="cancel()">Cancel</a>
    </li>
  </ul>
</li>
</form>
